export default __webpack_public_path__ + "static/media/IMG-2731.ce5685fb.jpg";